import logo from './logo.svg';
import './App.css';
import GlobalStyle from './styles/globalStyles';
import Header from './pages/Header';
import Hero from './pages/Hero';
import AboutUs from './pages/AboutUs';
import Footer from './pages/Footer';

import Tabletop from 'tabletop';
import { useEffect, useState } from 'react';
import Products from './pages/Products';
import Wrapper from './components/Wrapper';
import decoration_a from './assets/images/DecorationA.png';
import decoration_b from './assets/images/DecorationB.png';

import uuid from 'react-uuid';
import { ImageDecoration } from './pages/Products/styles';
import ContactUs from './pages/ContactUs';
import { isOpen } from './utils/isOpen';
// const URL_SHEET = '10YKb55LzkhOQzRB1qFDb6ggbBIdff3crgP1aQxuIkLk';
import jsonProductos from "./assets/jsonProductos/productos.json";

const App = () => {
	const [variables, setVariables] = useState([]);
	const [productos, setProductos] = useState([]);

	const init = () => {
		setProductos(jsonProductos.map((element) => {
			return { ...element, id: uuid() };
		}));
	}
	// 	Tabletop.init({
	// 		key: URL_SHEET,
	// 	}).then((data) => {
	// 		console.log(data);
	// 		setVariables(data.VARIABLES.elements);
	// 		setProductos(
	// 			data.PRODUCTOS.elements.map((element) => {
	// 				return { ...element, id: uuid() };
	// 			}),
	// 		);
	// 	});
	// };

	useEffect(() => {
		init();
	}, []);

	return (
		<>
			<GlobalStyle />
			<Header isOpen={isOpen(new Date())} />
			<Hero />
			<Wrapper>
				<AboutUs />
				<ImageDecoration left src={decoration_a} />
				<ImageDecoration right src={decoration_b} />
				{productos.length > 0 && <Products productos={productos} />}
				<ContactUs />
			</Wrapper>
			<Footer />
		</>
	);
};

export default App;
